import { createContext } from 'react'

export interface ZipCodeContextState {
  zipCode?: string | null
  updateZipCode: (val: string | undefined | null) => boolean
  isZipcodeModalOpen: boolean
  openZipcodeModal: (val: boolean) => void
}

const ZipCodeContext = createContext<ZipCodeContextState>({
  updateZipCode: () => true,
  isZipcodeModalOpen: false,
  openZipcodeModal: () => undefined,
})

// @i18n-ignore
const ZIP_CODE_CONTEXT_DISPLAY_NAME = 'Zip Code Context'
ZipCodeContext.displayName = ZIP_CODE_CONTEXT_DISPLAY_NAME

export default ZipCodeContext
